import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _CloudSnowIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M8.08235 1.04679C9.50123 0.90231 10.9341 1.0971 12.2629 1.61511C13.5918 2.13313 14.7784 2.95952 15.7252 4.02619C16.498 4.89686 17.0928 5.90727 17.4793 7.0002H18.0012C19.3783 7.00182 20.713 7.47715 21.7812 8.3464C22.8494 9.21566 23.586 10.4259 23.8675 11.774C24.1489 13.1221 23.958 14.526 23.3268 15.7501C22.6957 16.9741 21.6626 17.9437 20.4011 18.4962C19.8953 18.7178 19.3055 18.4873 19.084 17.9814C18.8624 17.4755 19.0929 16.8858 19.5988 16.6642C20.4398 16.2959 21.1285 15.6494 21.5493 14.8334C21.97 14.0174 22.0973 13.0815 21.9097 12.1827C21.722 11.284 21.231 10.4772 20.5188 9.89767C19.8068 9.31825 18.9172 9.00137 17.9992 9.0002H16.74C16.284 9.0002 15.8857 8.69174 15.7717 8.25024C15.4944 7.17619 14.9657 6.18344 14.2294 5.35381C13.493 4.52418 12.5701 3.88143 11.5365 3.47853C10.503 3.07563 9.38853 2.92413 8.28496 3.0365C7.18139 3.14887 6.12032 3.52191 5.18922 4.12486C4.25812 4.72781 3.48364 5.54341 2.92963 6.50443C2.37561 7.46546 2.05792 8.54439 2.00275 9.65229C1.94757 10.7602 2.15648 11.8654 2.61226 12.8767C3.06805 13.888 3.75765 14.7765 4.62424 15.469C5.05569 15.8138 5.12596 16.443 4.78119 16.8745C4.43642 17.3059 3.80716 17.3762 3.37571 17.0314C2.26153 16.1411 1.3749 14.9987 0.788889 13.6984C0.202881 12.3982 -0.0657213 10.9773 0.00522189 9.55281C0.0761651 8.12836 0.484622 6.74116 1.19693 5.50556C1.90923 4.26996 2.90498 3.22133 4.10212 2.44611C5.29925 1.67089 6.66347 1.19127 8.08235 1.04679Z"
        fill={iconColor}
      />
      <Path
        d="M7 16.0002C7 15.4479 7.44772 15.0002 8 15.0002H8.01C8.56228 15.0002 9.01 15.4479 9.01 16.0002C9.01 16.5525 8.56228 17.0002 8.01 17.0002H8C7.44772 17.0002 7 16.5525 7 16.0002Z"
        fill={iconColor}
      />
      <Path
        d="M8 19.0002C7.44772 19.0002 7 19.4479 7 20.0002C7 20.5525 7.44772 21.0002 8 21.0002H8.01C8.56228 21.0002 9.01 20.5525 9.01 20.0002C9.01 19.4479 8.56228 19.0002 8.01 19.0002H8Z"
        fill={iconColor}
      />
      <Path
        d="M11 18.0002C11 17.4479 11.4477 17.0002 12 17.0002H12.01C12.5623 17.0002 13.01 17.4479 13.01 18.0002C13.01 18.5525 12.5623 19.0002 12.01 19.0002H12C11.4477 19.0002 11 18.5525 11 18.0002Z"
        fill={iconColor}
      />
      <Path
        d="M12 21.0002C11.4477 21.0002 11 21.4479 11 22.0002C11 22.5525 11.4477 23.0002 12 23.0002H12.01C12.5623 23.0002 13.01 22.5525 13.01 22.0002C13.01 21.4479 12.5623 21.0002 12.01 21.0002H12Z"
        fill={iconColor}
      />
      <Path
        d="M15 16.0002C15 15.4479 15.4477 15.0002 16 15.0002H16.01C16.5623 15.0002 17.01 15.4479 17.01 16.0002C17.01 16.5525 16.5623 17.0002 16.01 17.0002H16C15.4477 17.0002 15 16.5525 15 16.0002Z"
        fill={iconColor}
      />
      <Path
        d="M16 19.0002C15.4477 19.0002 15 19.4479 15 20.0002C15 20.5525 15.4477 21.0002 16 21.0002H16.01C16.5623 21.0002 17.01 20.5525 17.01 20.0002C17.01 19.4479 16.5623 19.0002 16.01 19.0002H16Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const CloudSnowIcon = assignWithoutSideEffects(_CloudSnowIcon, {
  componentId: 'CloudSnowIcon',
});

export default CloudSnowIcon;
